export const defaultEmptyMetricString = 'Não se aplica' as const;

export const TIME_RESPONSAVEL_MANHATTAN = 'Manhattan' as const;

export enum FieldType {
    Input = 'Input',
    Checkbox = 'Checkbox',
    Button = 'Button',
    Radio = 'Radio',
    Dropdown = 'Dropdown',
}

export type MetricSpecificProperties = Record<string, string | number | boolean>;

export interface IMetric {
    readonly fields: Record<string, string | number | boolean | MetricSpecificProperties>;
    readonly type: string;
}

export function buildSpecificPropertiesField(specificProperties?: MetricSpecificProperties): Record<string, MetricSpecificProperties> {
    return specificProperties ? { 'Specific Properties': specificProperties } : {};
}
